import type { MagazineArticle } from '../helpers/magazineCategory';
import { useTranslations } from 'next-intl';
import { MagazineArticlesFeed } from '../MagazineArticlesFeed/MagazineArticlesFeed';
import { MagazineTrackMeta } from '../MagazineBody/MagazineTrackMeta';
import { MagazinePromotedCarousel } from '../MagazinePromotedCarousel/MagazinePromotedCarousel';

type MagazineHomePageProps = {
  pageNumber?: number;
  articles: readonly MagazineArticle[];
  promotedArticles: readonly MagazineArticle[];
  totalPages: number;
  baseImgUrl: string;
};

function MagazineHomePage({ pageNumber, articles, promotedArticles, totalPages, baseImgUrl }: MagazineHomePageProps) {
  const t = useTranslations('magazine.home');
  const currentPage = pageNumber ?? 1;
  const isFirstPage = currentPage === 1;
  const gridArticles = isFirstPage ? articles.slice(promotedArticles.length) : articles;
  const showPromotedCarousel = promotedArticles.length > 0;
  const showArticleGrid = gridArticles.length > 0;

  const leadingContent = showPromotedCarousel ? (
    <>
      <MagazinePromotedCarousel articles={promotedArticles} baseImgUrl={baseImgUrl} />
      {showArticleGrid && <hr className="my-8 w-full border-0 border-t border-dashed border-border" data-testid="magazine-home-page-divider" />}
    </>
  ) : undefined;

  return (
    <>
      <MagazineTrackMeta container="Home" />
      <MagazineArticlesFeed
        data-testid="magazine-home-page"
        articles={gridArticles}
        currentPage={currentPage}
        totalPages={totalPages}
        baseImgUrl={baseImgUrl}
        hrefContext={{ type: 'home' }}
        emptyMessage={t('empty')}
        isEmpty={articles.length === 0 && promotedArticles.length === 0}
        priorityFirstCard={!isFirstPage}
        leadingContent={leadingContent}
      />
    </>
  );
}

export { MagazineHomePage, type MagazineHomePageProps };
